/** 作品状态与内容校验的展示规则：徽标颜色、上架条件、已上架作品内容不合格的风险。 */

export const STATUS_VARIANT = { draft: 'info', published: 'success', unpublished: 'warning', archived: 'neutral', deleted: 'danger' }

export function packStatusKey(status) {
  return status === 'deleted' ? 'novelStudio.status.deleted' : `visualGameAdmin.novelPacks.status.${status}`
}
// 内容不合格一律红色，与创作台同一状态的颜色一致。
export const VALIDATION_VARIANT = { valid: 'success', invalid: 'danger' }

/**
 * 上架动作的状态（形态 6.6）：草稿或已下架、且内容校验通过才能上架，不需要版本；已上架的可以下架；已归档是终态。
 * @param {{ status: string, validation_status: string }} pack
 * @returns {'publishable'|'invalid'|'archived'|'deleted'|'listed'}
 */
export function listingState(pack) {
  if (pack.status === 'published') return 'listed'
  if (pack.status === 'archived') return 'archived'
  if (pack.status === 'deleted') return 'deleted'
  return pack.validation_status === 'valid' ? 'publishable' : 'invalid'
}

/** 已上架但内容不再通过校验：玩家新开局会失败。 */
export function isListedInvalid(pack) {
  return pack.status === 'published' && pack.validation_status === 'invalid'
}
